module.exports = __webpack_public_path__ + "img/photo_2024-03-22_19-38-50.c127ba5d.jpg";